import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, styled } from '@mui/material';

export const ButtonMainStyled = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== 'mt' &&
    prop !== 'mr' &&
    prop !== 'mb' &&
    prop !== 'ml' &&
    prop !== 'm' &&
    prop !== 'isOneLineName' &&
    prop !== 'isLoading' &&
    prop !== 'hasIcon',
})(({ theme, m, mt, mr, mb, ml, width, isOneLineName, hasIcon }) => {
  let margin = null;

  switch (m?.length) {
    case 4:
      margin = theme.spacing(m[0], m[1], m[2], m[3]);
      break;
    case 3:
      margin = theme.spacing(m[0], m[1], m[2]);
      break;
    case 2:
      margin = theme.spacing(m[0], m[1]);
      break;
    case 1:
      margin = theme.spacing(m[0]);
      break;
    default:
      margin = null;
  }

  const getOneLineNameStyles = () => {
    if (isOneLineName)
      return {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      };

    return null;
  };

  return {
    margin,
    marginTop: mt ? theme.spacing(mt) : null,
    marginRight: mr ? theme.spacing(mr) : null,
    marginBottom: mb ? theme.spacing(mb) : null,
    marginLeft: ml ? theme.spacing(ml) : null,
    ...getOneLineNameStyles(),
    ...(hasIcon && { gap: '8px' }),
    width,
  };
});

export const ButtonIconStyled = styled(FontAwesomeIcon)(() => ({
  fontSize: '16px',
  width: 'auto',
}));
